import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROLES } from '@app/core/models/Preset';
import { LibraryHostComponent } from '@app/library/components/content/library-host/library-host.component';
import { PlaylistHostComponent } from '@app/library/components/content/playlist-host/playlist-host.component';
import { TagTracksAllComponent } from '@app/library/components/content/tag-tracks-all/tag-tracks-all.component';
import { TrashAllComponent } from '@app/library/components/content/trash-all/trash-all.component';
import { LibraryBacsFindResolver } from '@app/library/resolvers/library-bacs-find.resolver';
import { LibrarySortParamsResolver } from '@app/library/resolvers/library-sort-params.resolver';
import { PlaylistFindResolver } from '@app/library/resolvers/playlist-find.resolver';
import { TagsFindResolver } from '@app/library/resolvers/tags-find.resolver';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { CanDeactivatePanelGuard } from '@radioking/shared/pannel-manager';

import { LibraryShellComponent } from './components/shell/library-shell/library-shell.component';

const routes: Routes = [
  {
    path: '',
    component: LibraryShellComponent,
    data: {
      title: marker('GLOBAL.WINDOW_TITLE.MEDIACENTER'),
      role: ROLES.LIBRARY,
    },
    resolve: {
      pagingParams: LibrarySortParamsResolver,
    },
    canDeactivate: [CanDeactivatePanelGuard],
    children: [
      // { path: 'all', component: LibraryAllComponent },

      {
        path: 'bac/:bacid',
        component: LibraryHostComponent,
        resolve: { bacs: LibraryBacsFindResolver },
      },
      {
        path: 'trash',
        component: TrashAllComponent,
      },
      {
        path: 'playlist/:playlistid',
        component: PlaylistHostComponent,
        resolve: { playlist: PlaylistFindResolver },
      },
      {
        path: 'tag/:tagid',
        component: TagTracksAllComponent,
        resolve: { tag: TagsFindResolver },
      },
      {
        path: '',
        redirectTo: 'bac/1',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LibraryRoutingModule {}
